import React, { useState } from 'react';
import ColumnVisibilityMenu from '../components/common/ColumnVisibilityMenu';

export interface ColumnConfig {
  [key: string]: boolean;
}

export interface UseColumnConfigurationProps {
  defaultColumns: ColumnConfig;
}

export interface UseColumnConfigurationReturn {
  columnVisibility: ColumnConfig;
  columnMenuAnchor: HTMLElement | null;
  handleColumnMenuOpen: (event: React.MouseEvent<HTMLElement>) => void;
  handleColumnMenuClose: () => void;
  toggleColumnVisibility: (columnKey: string) => void;
  ColumnMenu: React.FC<{ columns: Array<{ key: string; label: string; condition?: boolean }> }>;
}

export const useColumnConfiguration = ({
  defaultColumns,
}: UseColumnConfigurationProps): UseColumnConfigurationReturn => {
  const [columnVisibility, setColumnVisibility] = useState<ColumnConfig>(defaultColumns);
  const [columnMenuAnchor, setColumnMenuAnchor] = useState<HTMLElement | null>(null);

  const handleColumnMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setColumnMenuAnchor(event.currentTarget);
  };

  const handleColumnMenuClose = () => {
    setColumnMenuAnchor(null);
  };

  const toggleColumnVisibility = (columnKey: string) => {
    setColumnVisibility(prev => ({
      ...prev,
      [columnKey]: !prev[columnKey]
    }));
  };

  const ColumnMenu: React.FC<{ columns: Array<{ key: string; label: string; condition?: boolean }> }> = ({ columns }) => (
    <ColumnVisibilityMenu
      side
      anchorEl={columnMenuAnchor}
      onClose={handleColumnMenuClose}
      onToggle={toggleColumnVisibility}
      items={columns
        .filter(column => column.condition !== false)
        .map(column => ({ ...column, visible: Boolean(columnVisibility[column.key]) }))}
    />
  );

  return {
    columnVisibility,
    columnMenuAnchor,
    handleColumnMenuOpen,
    handleColumnMenuClose,
    toggleColumnVisibility,
    ColumnMenu,
  };
};
